var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeStoryIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5172_27644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 12.1201L30.4133 14.4535C31.36 14.6535 32 15.4535 32 16.4001V30.0001C32 31.1068 31.1067 32.0001 30 32.0001H18C18.3733 32.0001 18.6667 31.7068 18.6667 31.3335V30.6668H30C30.36 30.6668 30.6667 30.3735 30.6667 30.0001V16.4001C30.6667 16.0935 30.4533 15.8135 30.1467 15.7468L18.6667 13.4801V12.1201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 18.6665C26.3727 18.6665 26.666 18.9598 26.666 19.3332C26.666 19.7065 26.3727 19.9998 25.9993 19.9998H23.3327C22.9593 19.9998 22.666 19.7065 22.666 19.3332C22.666 18.9598 22.9593 18.6665 23.3327 18.6665H25.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 22.6665C26.3727 22.6665 26.666 22.9598 26.666 23.3332C26.666 23.7065 26.3727 23.9998 25.9993 23.9998H23.3327C22.9593 23.9998 22.666 23.7065 22.666 23.3332C22.666 22.9598 22.9593 22.6665 23.3327 22.6665H25.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 26.6665C26.3727 26.6665 26.666 26.9598 26.666 27.3332C26.666 27.7065 26.3727 27.9998 25.9993 27.9998H23.3327C22.9593 27.9998 22.666 27.7065 22.666 27.3332C22.666 26.9598 22.9593 26.6665 23.3327 26.6665H25.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 31.3331C18.6673 31.7065 18.374 31.9998 18.0007 31.9998C17.6273 31.9998 17.334 31.7065 17.334 31.3331V30.6665V12.6665C17.334 12.4665 17.4273 12.2798 17.574 12.1465C17.734 12.0265 17.934 11.9731 18.134 12.0131L18.6673 12.1198V13.4798V30.6665V31.3331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 30.6665V31.3332C17.3327 31.7065 17.626 31.9998 17.9993 31.9998H12.666C13.0393 31.9998 13.3327 31.7065 13.3327 31.3332V30.6665H17.3327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 6.6665C14.3727 6.6665 14.666 6.95984 14.666 7.33317C14.666 7.7065 14.3727 7.99984 13.9993 7.99984H11.3327C10.9593 7.99984 10.666 7.7065 10.666 7.33317C10.666 6.95984 10.9593 6.6665 11.3327 6.6665H13.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 11.3332C14.666 11.7065 14.3727 11.9998 13.9993 11.9998H11.3327C10.9593 11.9998 10.666 11.7065 10.666 11.3332C10.666 10.9598 10.9593 10.6665 11.3327 10.6665H13.9993C14.3727 10.6665 14.666 10.9598 14.666 11.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 14.6665C14.3727 14.6665 14.666 14.9598 14.666 15.3332C14.666 15.7065 14.3727 15.9998 13.9993 15.9998H11.3327C10.9593 15.9998 10.666 15.7065 10.666 15.3332C10.666 14.9598 10.9593 14.6665 11.3327 14.6665H13.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9993 18.6665C14.3727 18.6665 14.666 18.9598 14.666 19.3332C14.666 19.7065 14.3727 19.9998 13.9993 19.9998H11.3327C10.9593 19.9998 10.666 19.7065 10.666 19.3332C10.666 18.9598 10.9593 18.6665 11.3327 18.6665H13.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19.3332C8 19.7065 7.70667 19.9998 7.33333 19.9998H4.66667C4.29333 19.9998 4 19.7065 4 19.3332C4 18.9598 4.29333 18.6665 4.66667 18.6665H7.33333C7.70667 18.6665 8 18.9598 8 19.3332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 6.6665C7.70667 6.6665 8 6.95984 8 7.33317C8 7.7065 7.70667 7.99984 7.33333 7.99984H4.66667C4.29333 7.99984 4 7.7065 4 7.33317C4 6.95984 4.29333 6.6665 4.66667 6.6665H7.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 10.6665C7.70667 10.6665 8 10.9598 8 11.3332C8 11.7065 7.70667 11.9998 7.33333 11.9998H4.66667C4.29333 11.9998 4 11.7065 4 11.3332C4 10.9598 4.29333 10.6665 4.66667 10.6665H7.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 14.6665C7.70667 14.6665 8 14.9598 8 15.3332C8 15.7065 7.70667 15.9998 7.33333 15.9998H4.66667C4.29333 15.9998 4 15.7065 4 15.3332C4 14.9598 4.29333 14.6665 4.66667 14.6665H7.33333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0007 24.6665C12.0007 24.2932 11.694 23.9998 11.334 23.9998H7.33398C6.96065 23.9998 6.66732 24.2932 6.66732 24.6665V30.6665H5.33398V24.6665C5.33398 23.5598 6.22732 22.6665 7.33398 22.6665H11.334C12.4407 22.6665 13.334 23.5598 13.334 24.6665V30.6665H12.0007V24.6665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 30.6665H12.0007H13.334V31.3332C13.334 31.7065 13.0407 31.9998 12.6673 31.9998H6.00065C5.62732 31.9998 5.33398 31.7065 5.33398 31.3332V30.6665H6.66732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 0.266681L16.9867 2.49335C17.96 2.65335 18.6667 3.48001 18.6667 4.46668V12.12L18.1333 12.0133C17.9333 11.9733 17.7333 12.0267 17.5733 12.1467C17.4267 12.28 17.3333 12.4667 17.3333 12.6667V4.46668C17.3333 4.13335 17.0933 3.85335 16.7733 3.80001L2.12 1.58668C2.08 1.57335 2.04 1.57335 2 1.57335C1.84 1.57335 1.69333 1.62668 1.57333 1.73335C1.41333 1.86668 1.33333 2.04001 1.33333 2.24001V30C1.33333 30.3734 1.64 30.6667 2 30.6667H5.33333V31.3333C5.33333 31.7067 5.62667 32 6 32H2C0.893333 32 0 31.1067 0 30V2.24001C0 1.65335 0.253333 1.09335 0.706667 0.720015C1.16 0.333348 1.74667 0.173348 2.33333 0.266681Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5172_27644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStoryIcon4);
export default __webpack_public_path__ + "static/media/lifeStoryIcon4.d5f4c1c49cf8b42f99c2a05ca406b907.svg";
export { ForwardRef as ReactComponent };